<input class="search" [(ngModel)]="searchQuery" placeholder="Search for images" />
<button (click)="searchImages(searchQuery)" class="searchButton btn btn-primary" type="button">Find Images</button>

<p *ngIf="searching">Fetching data...</p>

<div *ngFor="let image of images" class="image-container">
  <img *ngIf="service=='pixabay'" src="{{ image.webformatURL }}" (click)="clickImage(image);">
  <img *ngIf="service=='giphy'" src="{{ image.images.original.url }}" (click)="clickImage(image);">
</div>
